import React from "react";
import { Tag } from "antd";
import { GiftOutlined } from "@ant-design/icons";
import moment from "moment";

const VoucherMessage = ({ voucherDetail }) => {
  if (!voucherDetail) return null;

  const {
    code,
    title,
    discountType,
    discountValue,
    maxDiscountAmount,
    currency = "JPY",
    startDate,
    endDate,
  } = voucherDetail;

  const discountText =
    discountType === "PERCENTAGE"
      ? `${discountValue}%`
      : `¥${(discountValue || 0).toLocaleString()}`;

  const maxText =
    discountType === "PERCENTAGE" && maxDiscountAmount > 0
      ? ` (tối đa ¥${maxDiscountAmount.toLocaleString()})`
      : "";

  return (
    <div
      style={{
        width: 260,
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid #f0d0e0",
        background: "linear-gradient(135deg, #fff5f8 0%, #fff0f5 100%)",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #eb2f96 0%, #f759ab 100%)",
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <GiftOutlined style={{ fontSize: 20, color: "#fff" }} />
        <span style={{ color: "#fff", fontWeight: 600, fontSize: 14 }}>
          Voucher
        </span>
      </div>

      {/* Body */}
      <div style={{ padding: "12px 14px" }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: 14,
            marginBottom: 6,
            color: "#333",
          }}
        >
          {title || "Voucher giảm giá"}
        </div>

        <div
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: "#eb2f96",
            marginBottom: 8,
          }}
        >
          Giảm {discountText}
          {maxText && (
            <span style={{ fontSize: 12, fontWeight: 400, color: "#999" }}>
              {maxText}
            </span>
          )}
        </div>

        {/* Code */}
        <div
          style={{
            border: "2px dashed #eb2f96",
            borderRadius: 8,
            padding: "8px 12px",
            textAlign: "center",
            background: "#fff",
            marginBottom: 8,
          }}
        >
          <span
            style={{
              fontFamily: "monospace",
              fontSize: 16,
              fontWeight: 700,
              letterSpacing: 2,
              color: "#eb2f96",
            }}
          >
            {code}
          </span>
        </div>

        {/* Dates */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 11,
            color: "#999",
          }}
        >
          <span>
            {startDate ? moment(startDate).format("DD/MM/YYYY") : ""} -{" "}
            {endDate ? moment(endDate).format("DD/MM/YYYY") : ""}
          </span>
          {new Date(endDate) < new Date() ? (
            <Tag color="red" style={{ fontSize: 10, margin: 0 }}>
              Hết hạn
            </Tag>
          ) : (
            <Tag color="green" style={{ fontSize: 10, margin: 0 }}>
              Còn hiệu lực
            </Tag>
          )}
        </div>
      </div>
    </div>
  );
};

export default VoucherMessage;
